module.exports = __webpack_public_path__ + "img/wso2.f758f262.png";